<!-- 版本订单 -->
<template>
    <div>
        <div class="header">
            <Input
                class="w200 mr24 mb24"
                type="text"
                v-model="storePrams.keywords"
                placeholder="请输入版本名称"
            ></Input>
            <Select
                class="w200 mr24 mb24"
                v-model="storePrams.status"
                clearable
                filterable
            >
                <Option
                    v-for="item in statusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                >
            </Select>
            <Button
                class="theme-bc mb24"
                icon="ios-search"
                type="warning"
                @click="goSearch"
                >确认搜索</Button
            >
        </div>
        <div class="content">
            <Button
                class="theme-bc mb24"
                icon="md-add-circle"
                type="warning"
                @click="gomodal"
                >增加版本</Button
            >
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="status">
                    <div class="flex-c">
                        <i-switch
                            v-model="row.status"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                            @on-change="changeStatus(row)"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button
                            type="primary"
                            ghost
                            label="small"
                            @click="gomodal(row)"
                            >编辑</Button
                        >
                        <Button
                            type="error"
                            ghost
                            label="small"
                            @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="text-align-right mt24">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>

        <!-- 新增/编辑 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            width="700"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="form_item"
                    label-position="right"
                    :label-width="130"
                >
                    <FormItem label="序号：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.sort"
                            placeholder="请输入序号"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>正序，序号越小，越在前面</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="版本名称：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.title"
                            placeholder="请输入版本名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="价格：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.price"
                            placeholder="请输入价格"
                            ><span slot="append">元</span></Input
                        >
                    </FormItem>
                    <FormItem label="等级：">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.grade"
                            placeholder="请输入等级"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>等级越大代表版本越高</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="有效期：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.days"
                            placeholder="请输入有效期天数"
                            ><span slot="append">天</span></Input
                        >
                    </FormItem>
                    <FormItem label="按钮标题：">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.btn_title"
                            placeholder="请输入按钮标题"
                        ></Input>
                    </FormItem>
                    <FormItem label="子标题:">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.sub_title"
                            placeholder="请输入子标题"
                            ><span slot="append"
                                ><ColorPicker
                                    v-model="form_item.sub_font_color" /></span
                        ></Input>
                    </FormItem>
                    <div class="color-container">
                        <FormItem label="子标题背景色：">
                            <ColorPicker v-model="form_item.sub_bg_color" />
                        </FormItem>
                        <FormItem label="主题色：">
                            <ColorPicker v-model="form_item.bg_color" />
                        </FormItem>
                    </div>
                    <FormItem label="溯源码数量:">
                        <Input
                            class="w300"
                            type="number"
                            v-model="form_item.qrcode_num"
                            placeholder="请输入版本附带的溯源码数量"
                        ></Input>
                    </FormItem>
                    <FormItem label="链接:">
                        <Input
                            class="w300"
                            type="text"
                            v-model="form_item.link"
                            placeholder="请输入链接"
                        ></Input>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="tooltip-icon"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D"
                            />
                            <div slot="content">
                                <p>填写链接，点击购买按钮则自动跳转到该链接处</p>
                            </div>
                        </Tooltip>
                    </FormItem>
                    <FormItem label="是否有水印:">
                        <i-switch
                            v-model="form_item.is_watermark"
                            size="large"
                            true-color="#FF761D "
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">开启</span>
                            <span slot="close">关闭</span>
                        </i-switch>
                    </FormItem>
                    <FormItem label="选择插件：">
                        <CheckboxGroup
                            v-model="form_item.apps"
                            v-for="(item, index) in appsList"
                            :key="index"
                        >
                            <Checkbox :label="item.id + ''"
                                ><span>{{ item.title }}</span></Checkbox
                            >
                        </CheckboxGroup>
                    </FormItem>
                    <FormItem label="版本明细：">
                        <div
                            v-for="(item, index) in form_item.intros"
                            :key="index"
                        >
                            <div class="details-container">
                                <div>
                                    <div>
                                        <Input
                                            class="w150"
                                            type="text"
                                            v-model="item.key"
                                            placeholder="请输入"
                                        ></Input>
                                        <Input
                                            class="w200 ml24"
                                            type="text"
                                            v-model="item.value"
                                            placeholder="请输入"
                                        ></Input>
                                    </div>
                                    <Input
                                        class="w374"
                                        type="text"
                                        v-model="item.desc"
                                        placeholder="请输入（用英文逗号分隔）"
                                    ></Input>
                                </div>
                                <img
                                    src="@/assets/help_del.png"
                                    class="details-icon"
                                    @click="godelDetails(index)"
                                />
                            </div>
                        </div>
                        <Button
                            class="theme-bc"
                            icon="md-add-circle"
                            type="warning"
                            @click="goAddDetails"
                            >添加</Button
                        >
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    version,
    version_save,
    version_change,
    version_last_grade,
    version_del,
    version_sort,
    account_app_select,
    version_infos,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 30,
                keywords: "",
                status: -1,
            },
            total: 0,
            statusList: [
                { id: -1, name: "全部" },
                { id: 0, name: "下架" },
                { id: 1, name: "上架" },
            ],
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "序号", key: "sort", align: "center" },
                { title: "版本名称", key: "title", align: "center" },
                { title: "状态", slot: "status", align: "center" },
                { title: "创建时间", key: "created_at", align: "center" },
                { title: "金额", key: "price", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            modals: false,
            modalTitle: "",
            form_item: {
                title: "",
                price: "",
                btn_title: "",
                sub_title: "",
                sub_font_color: "",
                sub_bg_color: "",
                bg_color: "",
                qrcode_num: "",
                link: "",
                sort: "",
                is_watermark: 0,
                apps: [],
                id: "",
                days: "365",
                intros: [],
                grade: "",
            },
            appsList: [],
        };
    },
    mounted() {
        this.getList();
        this.getVersionApps();
    },
    methods: {
        getList() {
            version(this.storePrams).then((res) => {
                this.dataTable = res.data.data;
                this.total = res.data.total;
            });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },
        getGrade() {
            version_last_grade().then((res) => {
                this.form_item.grade = res.data.grade;
            });
        },
        getSort() {
            version_sort().then((res) => {
                this.form_item.sort = res.data.sort;
            });
        },
        gomodal(row) {
            if (row.id) {
                this.modalTitle = "编辑版本";
                this.form_item.id = row.id;
                this.getVersionInfos();
            } else {
                this.modalTitle = "增加版本";
                this.form_item.title = "";
                this.form_item.price = "";
                this.form_item.btn_title = "";
                this.form_item.sub_title = "";
                this.form_item.sub_font_color = "";
                this.form_item.sub_bg_color = "";
                this.form_item.bg_color = "";
                this.form_item.qrcode_num = "";
                this.form_item.link = "";
                this.form_item.is_watermark = 0;
                this.form_item.apps = [];
                this.form_item.id = "";
                this.form_item.days = "365";
                this.form_item.intros = [];
                this.getGrade();
                this.getSort();
            }
            setTimeout(() => {
                this.modals = true;
            }, 500);
        },
        getVersionInfos() {
            version_infos({ id: this.form_item.id })
                .then((res) => {
                    this.form_item.title = res.data.title;
                    this.form_item.price = res.data.price;
                    this.form_item.btn_title = res.data.btn_title;
                    this.form_item.sub_title = res.data.sub_title;
                    this.form_item.sub_font_color = res.data.sub_font_color;
                    this.form_item.sub_bg_color = res.data.sub_bg_color;
                    this.form_item.bg_color = res.data.bg_color;
                    this.form_item.qrcode_num = res.data.qrcode_num;
                    this.form_item.link = res.data.link;
                    this.form_item.sort = res.data.sort;
                    this.form_item.grade = res.data.grade;
                    this.form_item.is_watermark = res.data.is_watermark;
                    if(res.data.apps){
                        this.form_item.apps = res.data.app_ids;
                    }else {
                        this.form_item.apps = [];
                    }
                    this.form_item.days = res.data.days;
                    this.form_item.intros = res.data.intros;
                    this.form_item.intros = res.data.intros.map((item) => {
                        return {
                            ...item,
                            desc: Array.isArray(item.desc)
                                ? item.desc.join(",")
                                : String(item.desc || ""),
                        };
                    });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        // 确定
        submitModal() {
            version_save(this.form_item)
                .then((res) => {
                    this.getList();
                    this.modals = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelModal() {
            this.modals = false;
        },
        changeStatus(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    version_change({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？",
                onOk: () => {
                    version_del({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        getVersionApps() {
            account_app_select()
                .then((res) => {
                    this.appsList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goAddDetails() {
            this.form_item.intros.push({
                key: "",
                value: "",
                desc: "",
            });
        },
        godelDetails(index) {
            this.form_item.intros.splice(index, 1);
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background-color: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.text-align-right {
    text-align: right;
}
.tooltip-icon {
    margin-left: 10px;
    cursor: pointer;
}
.color-container {
    width: 430px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.w150 {
    width: 150px;
}
.details-container {
    margin-bottom: 12px;
    padding: 12px;
    width: 444px;
    display: flex;
    align-items: center;
    border: 1px dashed #ccc;
    border-radius: 4px;
}
.details-icon {
    margin-left: 24px;
    min-width: 20px;
    width: 20px;
    min-height: 20px;
    height: 20px;
}
.w374 {
    margin-top: 12px;
    width: 374px;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-checkbox-group.ivu-checkbox-default {
    display: inline-block;
}
::v-deep .ivu-input-group-append {
    padding: 0px 7px !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
</style>